module.exports = __webpack_public_path__ + "img/icon_flag_hk@2x.d26105d8.png";